import React, { useContext } from 'react';
import { TimeAgo } from './TimeAgo';
import { WSContext } from '../contexts/WSContext';
import { AuthContext } from '../reducers/Auth/AuthContext';
import { EventsStoreContext } from '../reducers/Events/EventsContext';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';

const CallCard = (props) => {
  const { event } = props;
  const { WSConnection } = useContext(WSContext);
  const [authState] = useContext(AuthContext);
  const [, dispatch] = useContext(EventsStoreContext);

  const {
    user: { placeId, alias: assignee },
  } = authState;

  const { userId, pointId, createdAt, details } = event;

  const hasPaymentCashRequest = details.payment && details.payment.cash;
  const hasPaymentCardRequest = details.payment && details.payment.card;
  const hasAnyPayment = hasPaymentCashRequest || hasPaymentCardRequest;

  const confirmCall = async () => {
    try {
      const message = { type: 'CALL_CONFIRMED', payload: { userId, placeId, pointId, assignee } };
      const callCompleteMessage = JSON.stringify(message);
      await WSConnection.send(callCompleteMessage);
      await dispatch({ type: 'CALL_COMPTETED', payload: { pointId, assignee } });
    } catch (error) {
      console.error('ERROR', error);
    }
  };

  let iconToShow = <CircleNotificationsIcon className="txt-white s-64-i" />;
  let message = 'GO TO';
  if (hasAnyPayment) {
    iconToShow = hasPaymentCashRequest ? (
      <LocalAtmIcon className="txt-success s-64-i" />
    ) : (
      <CreditCardIcon className="txt-info s-64-i" />
    );
    message = hasPaymentCashRequest ? 'PLATA CASH' : 'PLATA CARD';
  }

  return (
    <div className="p-rel f-c f-dirc f-jcsb m-4 W100 br-2 fds-3 bg-yellow">
      <div className="f-c f-dirc f-jcsb H100" style={{ height: 128 }}>
        <div className="f-c f-jcsb">
          <div className="f-c f-dirc f-aic f-jcc">{iconToShow}</div>
          <h1 className="f3b mp0 f40 ta-r f-1 mr-8 txt-black">{pointId}</h1>
        </div>
        <div className="f-c pc-lr pb-4">
          <span className="f3b f08 ta-l f-1 txt-black">{message}</span>
          <TimeAgo className="f3b f08 ta-r f-1 txt-black" date={createdAt} />
        </div>
      </div>
      <button
        className="f3b f10 pt-16 pb-16 W100 bg-info txt-white br-2 f-ls0"
        onClick={confirmCall}
      >
        CONFIRM
      </button>
    </div>
  );
};

export { CallCard };
